var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 77,
    viewBox: "0 0 74 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-\\u062F\\u0631\\u06AF\\u0627\\u0647_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A_\\u0627\\u06A9\\u062A\\u06CC\\u0648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 77
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u062F\\u0631\\u06AF\\u0627\\u0647_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A_\\u0627\\u06A9\\u062A\\u06CC\\u0648",
    "data-name": "\\u062F\\u0631\\u06AF\\u0627\\u0647 \\u067E\\u0631\\u062F\\u0627\\u062E\\u062A \\u0627\\u06A9\\u062A\\u06CC\\u0648",
    clipPath: "url(#clip-\\u062F\\u0631\\u06AF\\u0627\\u0647_\\u067E\\u0631\\u062F\\u0627\\u062E\\u062A_\\u0627\\u06A9\\u062A\\u06CC\\u0648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(-876 -169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(-54.956 40.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(935 170.819)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 32.444,
    cy: 31.768,
    rx: 32.444,
    ry: 31.768,
    fill: "#edf6ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Documents_File_Contacts",
    "data-name": "Documents, File, Contacts",
    transform: "translate(875.868 210.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M0,0H70.946V70.946H0Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shop",
    transform: "translate(896 188.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M0,0H33.544V33.544H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M4.22,10.89V24.875",
    transform: "translate(1.135 4.319)",
    fill: "none",
    stroke: "#5098ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M19.78,10.89V24.875",
    transform: "translate(7.862 4.319)",
    fill: "none",
    stroke: "#5098ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M.036.173A52.04,52.04,0,0,1,8.369-.12c6.5.065,9.674,0,9.674,0L21,0V14H0Z",
    transform: "translate(6 14.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M2,20.89H29.95",
    transform: "translate(0.797 8.305)",
    fill: "rgba(255,0,0,0)",
    stroke: "#5098ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M5.215,13.989A3.076,3.076,0,0,1,2.324,9.595l2.4-4.723A3.3,3.3,0,0,1,7.676,3.111h16.6a3.3,3.3,0,0,1,2.956,1.761l2.4,4.723a3.076,3.076,0,0,1-2.891,4.394,3.341,3.341,0,0,1-3.586-3.025V10.9a3.367,3.367,0,0,1-3.586,3.092A3.367,3.367,0,0,1,15.978,10.9a3.367,3.367,0,0,1-3.586,3.092A3.367,3.367,0,0,1,8.806,10.9v.067a3.348,3.348,0,0,1-3.59,3.025Z",
    transform: "translate(0.797 1.24)",
    fill: "#5098ef",
    stroke: "#5098ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("text", {
    id: "API",
    transform: "translate(905 214)",
    fill: "#5098ef",
    fontSize: 9,
    fontFamily: "Vazir-Black, Vazir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "API"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/api-icon.744c411108dc8ec5a1f84206499e76ca.svg";
export { ForwardRef as ReactComponent };